import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { ProgressBarService } from '../shared/progress-bar.service';

@Component({
  selector: 'app-involved-parties.component',
  templateUrl: './involved-parties.component.html',
  styleUrls: ['./involved-parties.component.css', '../shared/css/common.css']
})
export class InvlovedPartiesComponent implements OnInit {
  isformloaded: boolean = false;
  instructionText!: string | null;
  isInstruction: boolean = false;
  isFormsValid: boolean = false;

  payorkey: number;
  isMember = false;
  profileMasterTypeKey: any;
  isExternalReferringParty: string = "No";
  primaryColor?: string = "";
  involvedPartyControl: any;
  involvedPartyFormPart = this.referalFormBuilder.group({});
  childFormValid: boolean = false;
  primaryInvolvedPartyDetails: any;
  providerDetails: any;
  memberDetails: any;
  nonEnumeratedProviderDetails: any;
  nonEnumeratedOrganizationDetails: any;
  nonEnumeratedIndividualDetails: any;
  isFormLoaded: boolean = false;
  subjecyTypeId: any;

  constructor(
    private referalFormBuilder: FormBuilder,
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal,
    private progressBarService: ProgressBarService
  ) {
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
  }

  formdata: any | null;
  referalForm = this.referalFormBuilder.group({});
  additionalForm = this.referalFormBuilder.group({});
  referalFormData: any = {};
  additionalFormData: any = {};

  ngOnInit(): void {
    this.formdata = JSON.parse(sessionStorage.getItem("activeformdata") ?? "");
    this.providerDetails = JSON.parse(JSON.stringify(this.formdata.providerDetails));
    this.memberDetails = JSON.parse(JSON.stringify(this.formdata.memberDetails));
    this.nonEnumeratedProviderDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedProviderDetails));
    this.nonEnumeratedOrganizationDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedOrganizationDetails));
    this.nonEnumeratedIndividualDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedIndividualDetails));
    this.involvedPartyControl = this.formdata.witnessDetails.controls.slice(1, 2);
    this.referalFormData["controls"] = this.formdata.extenalReferall.controls.slice(0,1);
    this.additionalFormData["controls"] = this.formdata.extenalReferall.controls.slice(1,3);
    this.isExternalReferringParty = this.formdata.extenalReferall.controls.find((x: { name: string; }) => x.name == "isExternalReferal").value;

    this.vendorService.getLeadHeaders(this.payorkey).subscribe((result) => {
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText = result.Instruction;
      instructionText = instructionText.replace('<img ', '<img title="Header" ')
      this.instructionText = instructionText;
      this.referalForm.valueChanges.subscribe(() => this.formValidate());
      this.additionalForm.valueChanges.subscribe(() => this.formValidate());
    });
    this.loadPartiesInvolved();
    setTimeout(() => {
      this.progressBarService.sendData(true);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      let involvedPartyElement: any = document.getElementById("involvedType");
      if(involvedPartyElement != null) {
        involvedPartyElement.disabled = true;
      }
    });
  }

  loadPartiesInvolved() {
    this.vendorService.getInvolvedPartiesLookup(this.payorkey).subscribe((result) => {

      let selectedpartyId = this.formdata.witnessDetails.controls.find((x: { name: string; }) => x.name == "involvedType").value;
      if (!this.involvedPartyControl.find((x: { name: string; }) => x.name == "involvedType").value) {
        this.involvedPartyControl.find((x: { name: string; }) => x.name == "involvedType").options = result.map(x => { return { "value": x.Id, "key": x.Title } });
        setTimeout(() => {
          const involvedTypeValue = this.involvedPartyControl.find((x: { name: string; }) => x.name == "involvedType").value;
          if (involvedTypeValue) {
            (this.involvedPartyFormPart.get('involvedType') as any)?.setValue(involvedTypeValue);
          }
        }, 10);
      }
      let selectedparty = result.find(x => x.Id == selectedpartyId);
      if (selectedparty) {
        this.profileMasterTypeKey = selectedparty.ProfileMasterTypeKey;
        this.subjecyTypeId = selectedparty.SubjectTypeKey;
        this.isFormLoaded = true;
        this.formdata.involvedParties.data.forEach((item: any) => {
          if(item.isPrimary) {
            if(item.formControlDetails != null && item.formControlDetails.controls != null && item.formControlDetails.controls.length > 0
               && this.profileMasterTypeKey == item.profileMasterTypeKey) {
              let involvedPartyDetails = JSON.parse(JSON.stringify(item.formControlDetails));
              if (this.profileMasterTypeKey === 1) {
                this.formdata.providerDetails = JSON.parse(JSON.stringify(involvedPartyDetails));
              }
              else if (this.profileMasterTypeKey === 2) {
                this.formdata.memberDetails = JSON.parse(JSON.stringify(involvedPartyDetails));
              }
              else if (this.profileMasterTypeKey === 3) {
                this.formdata.nonEnumeratedProviderDetails = JSON.parse(JSON.stringify(involvedPartyDetails));
              }
              else if (this.profileMasterTypeKey === 4) {
                this.formdata.nonEnumeratedOrganizationDetails = JSON.parse(JSON.stringify(involvedPartyDetails));
              }
              else if (this.profileMasterTypeKey === 5) {
                this.formdata.nonEnumeratedIndividualDetails = JSON.parse(JSON.stringify(involvedPartyDetails));
              }

              this.primaryInvolvedPartyDetails = involvedPartyDetails;
            }
            else {
              if (this.profileMasterTypeKey === 1) {
                this.primaryInvolvedPartyDetails = this.formdata.providerDetails;
              }
              else if (this.profileMasterTypeKey === 2) {
                this.primaryInvolvedPartyDetails = this.formdata.memberDetails;
              }
              else if (this.profileMasterTypeKey === 3) {
                this.primaryInvolvedPartyDetails = this.formdata.nonEnumeratedProviderDetails;
              }
              else if (this.profileMasterTypeKey === 4) {
                this.primaryInvolvedPartyDetails = this.formdata.nonEnumeratedOrganizationDetails;
              }
              else if (this.profileMasterTypeKey === 5) {
                this.primaryInvolvedPartyDetails = this.formdata.nonEnumeratedIndividualDetails;
              }
            }
          }
        });
        setTimeout(()=> {
          this.cdref.detectChanges();
        });
      }
    });
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }
  
  back() {
    
    this.isFormLoaded = false;
    if (this.profileMasterTypeKey === 1) {
      this.formdata.providerDetails = JSON.parse(JSON.stringify(this.providerDetails));
    }
    else if (this.profileMasterTypeKey === 2) {
      this.formdata.memberDetails = JSON.parse(JSON.stringify(this.memberDetails));
    }
    else if (this.profileMasterTypeKey === 3) {
      this.formdata.nonEnumeratedProviderDetails = JSON.parse(JSON.stringify(this.nonEnumeratedProviderDetails));
    }
    else if (this.profileMasterTypeKey === 4) {
      this.formdata.nonEnumeratedOrganizationDetails = JSON.parse(JSON.stringify(this.nonEnumeratedOrganizationDetails));
    }
    else if (this.profileMasterTypeKey === 5) {
      this.formdata.nonEnumeratedIndividualDetails = JSON.parse(JSON.stringify(this.nonEnumeratedIndividualDetails));
    }
    
    if(this.isFormsValid) {
      window.sessionStorage.setItem("InvolvedPartyFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("InvolvedPartyFormValid");
    }
    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
    this.router.navigate(['witness']);
    setTimeout(() => {
      this.progressBarService.sendData(true);
    });
  }

  valueChange(data: any) {
    if (data.name == 'isExternalReferal') {
      this.isExternalReferringParty = data.value.srcElement.value;
    }

    if(data.name == 'involvedType') {
      let selectedPartyId = this.formdata.witnessDetails.controls.find((x: { name: string; }) => x.name == "involvedType").value;
      this.vendorService.getInvolvedPartyById(selectedPartyId, this.payorkey).subscribe((party) => {
        sessionStorage.setItem("selectedProfileMasterTypeKey", party.ProfileMasterTypeKey?.toString() ?? "");
        this.formdata.selectedProfileMasterTypeKey = party.ProfileMasterTypeKey;
        this.profileMasterTypeKey = party.ProfileMasterTypeKey;
        sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
      });
    }

    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
    this.formValidate();
    setTimeout(() => {
      this.cdref.detectChanges();
    });
  }

  openInstruction() {

    const result = this.modalService.open(InstructionsComponent, { size: 'lg', ariaLabelledBy: 'Instructions' });
    result.componentInstance.name = this.instructionText;
  }

  formValidate() {
    let isFormsValid = false;
    if (this.isExternalReferringParty == 'Yes') {
        if (this.referalForm.valid && this.additionalForm.valid && this.childFormValid) {
          isFormsValid = true;
        } else {
          isFormsValid = false;
        }
    } else if (this.isExternalReferringParty == "No") {
      if (this.referalForm.valid && this.childFormValid) {
        isFormsValid = true;
      } else {
        isFormsValid = false;
      }
    }
    
    this.isFormsValid = isFormsValid;
    this.cdref.detectChanges();
    if(this.isFormsValid) {
      window.sessionStorage.setItem("InvolvedPartyFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("InvolvedPartyFormValid");
    }
  }

  openAdditionalInvolvedParties() {
    this.isFormLoaded = false;
    this.updateInvolvedPartyDetails();
    if (this.profileMasterTypeKey === 1) {
      this.formdata.providerDetails = JSON.parse(JSON.stringify(this.providerDetails));
    }
    else if (this.profileMasterTypeKey === 2) {
      this.formdata.memberDetails = JSON.parse(JSON.stringify(this.memberDetails));
    }
    else if (this.profileMasterTypeKey === 3) {
      this.formdata.nonEnumeratedProviderDetails = JSON.parse(JSON.stringify(this.nonEnumeratedProviderDetails));
    }
    else if (this.profileMasterTypeKey === 4) {
      this.formdata.nonEnumeratedOrganizationDetails = JSON.parse(JSON.stringify(this.nonEnumeratedOrganizationDetails));
    }
    else if (this.profileMasterTypeKey === 5) {
      this.formdata.nonEnumeratedIndividualDetails = JSON.parse(JSON.stringify(this.nonEnumeratedIndividualDetails));
    }
    
    var tempArr = {
      controls: [],
      subcontrols: []
    }
    
    tempArr.controls = this.referalFormData.controls.concat(this.additionalFormData.controls);
    this.formdata.extenalReferall = tempArr;
    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
    if(this.isFormsValid) {
      window.sessionStorage.setItem("InvolvedPartyFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("InvolvedPartyFormValid");
    }

    this.router.navigate(['additionalInvolvedParties']);
  }

  updateInvolvedPartyDetails() {

    let formControlDetails: any;
    this.formdata = JSON.parse(sessionStorage.getItem("activeformdata") ?? "");
    if (this.profileMasterTypeKey === 1) {
      formControlDetails = JSON.parse(JSON.stringify(this.formdata.providerDetails));
      this.primaryInvolvedPartyDetails = formControlDetails;
      let firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "pFirstName").value;
      let middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "pMiddleName").value;
      let lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "pLastName").value;
      const selectedPartyId = parseInt(this.involvedPartyControl[0].value);
      this.formdata.involvedParties.data.forEach((item: any) => {
        if(item.isPrimary) {
          item.subjectTypeKey = this.subjecyTypeId;
          item.subjectType = this.involvedPartyControl[0].options.find((option: any) =>  option.value == selectedPartyId)?.key;
          item.isExternalReferal = this.formdata.extenalReferall.controls.find((x: { name: string; }) => x.name == "isExternalReferal").value == 'Yes';
          item.formControlDetails = formControlDetails;
          item.organization = (lastName == ''? '' : lastName + ', ' ) + firstName +' ' + (middleName?? '');
          item.profileMasterTypeKey = this.profileMasterTypeKey;
          item.externalReferalReport = item.isExternalReferal ? this.additionalFormData.controls[0].value : '';
          item.externalReferalAddInfo = item.isExternalReferal ? this.additionalFormData.controls[1].value : '';
        }
      });
    }
    else if (this.profileMasterTypeKey === 2) {
      formControlDetails = JSON.parse(JSON.stringify(this.formdata.memberDetails));
      this.primaryInvolvedPartyDetails = formControlDetails;
      let firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "mFirstName").value;
      let middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "mMiddleName").value;
      let lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "mLastName").value;
      const selectedPartyId = parseInt(this.involvedPartyControl[0].value);
      this.formdata.involvedParties.data.forEach((item: any) => {
        if(item.isPrimary) {
          item.subjectTypeKey = this.subjecyTypeId;
          item.subjectType = this.involvedPartyControl[0].options.find((option: any) =>  option.value == selectedPartyId)?.key;
          item.isExternalReferal = this.formdata.extenalReferall.controls.find((x: { name: string; }) => x.name == "isExternalReferal").value == 'Yes';
          item.formControlDetails = formControlDetails;
          item.organization = (lastName == ''? '' : lastName + ', ' ) + firstName +' ' + (middleName?? '');
          item.profileMasterTypeKey = this.profileMasterTypeKey;
          item.externalReferalReport = item.isExternalReferal ? this.additionalFormData.controls[0].value : '';
          item.externalReferalAddInfo = item.isExternalReferal ? this.additionalFormData.controls[1].value : '';
        }
      });
    }
    else if (this.profileMasterTypeKey === 3) {
      formControlDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedProviderDetails));
      this.primaryInvolvedPartyDetails = formControlDetails;
      let firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepFirstName").value;
      let middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepMiddleName").value;
      let lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepLastName").value;
      const selectedPartyId = parseInt(this.involvedPartyControl[0].value);
      this.formdata.involvedParties.data.forEach((item: any) => {
        if(item.isPrimary) {
          item.subjectTypeKey = this.subjecyTypeId;
          item.subjectType = this.involvedPartyControl[0].options.find((option: any) =>  option.value == selectedPartyId)?.key;
          item.isExternalReferal = this.formdata.extenalReferall.controls.find((x: { name: string; }) => x.name == "isExternalReferal").value == 'Yes';
          item.formControlDetails = formControlDetails;
          item.organization = (lastName == ''? '' : lastName + ', ' ) + firstName +' ' + (middleName?? '');
          item.profileMasterTypeKey = this.profileMasterTypeKey;
          item.externalReferalReport = item.isExternalReferal ? this.additionalFormData.controls[0].value : '';
          item.externalReferalAddInfo = item.isExternalReferal ? this.additionalFormData.controls[1].value : '';
        }
      });
    }
    else if (this.profileMasterTypeKey === 4) {
      formControlDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedOrganizationDetails));
      this.primaryInvolvedPartyDetails = formControlDetails;
      let firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactFirstName").value;
      let middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactMiddleName").value;
      let lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactLastName").value;
      const selectedPartyId = parseInt(this.involvedPartyControl[0].value);
      this.formdata.involvedParties.data.forEach((item: any) => {
        if(item.isPrimary) {
          item.subjectTypeKey = this.subjecyTypeId;
          item.subjectType = this.involvedPartyControl[0].options.find((option: any) =>  option.value == selectedPartyId)?.key;
          item.isExternalReferal = this.formdata.extenalReferall.controls.find((x: { name: string; }) => x.name == "isExternalReferal").value == 'Yes';
          item.formControlDetails = formControlDetails;
          item.organization = (lastName == ''? '' : lastName + ', ' ) + firstName +' ' + (middleName?? '');
          item.profileMasterTypeKey = this.profileMasterTypeKey;
          item.externalReferalReport = item.isExternalReferal ? this.additionalFormData.controls[0].value : '';
          item.externalReferalAddInfo = item.isExternalReferal ? this.additionalFormData.controls[1].value : '';
        }
      });
    }
    else if (this.profileMasterTypeKey === 5) {
      formControlDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedIndividualDetails));
      this.primaryInvolvedPartyDetails = formControlDetails;
      let firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiFirstName").value;
      let middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiMiddleName").value;
      let lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiLastName").value;
      const selectedPartyId = parseInt(this.involvedPartyControl[0].value);
      this.formdata.involvedParties.data.forEach((item: any) => {
        if(item.isPrimary) {
          item.subjectTypeKey = this.subjecyTypeId;
          item.subjectType = this.involvedPartyControl[0].options.find((option: any) =>  option.value == selectedPartyId)?.key;
          item.isExternalReferal = this.formdata.extenalReferall.controls.find((x: { name: string; }) => x.name == "isExternalReferal").value == 'Yes';
          item.formControlDetails = formControlDetails;
          item.organization = (lastName == ''? '' : lastName + ', ' ) + firstName +' ' + (middleName?? '');
          item.profileMasterTypeKey = this.profileMasterTypeKey;
          item.externalReferalReport = item.isExternalReferal ? this.additionalFormData.controls[0].value : '';
          item.externalReferalAddInfo = item.isExternalReferal ? this.additionalFormData.controls[1].value : '';
        }
      });
    }
    
    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
  }

  formValidationEvent(data: any) {
    this.childFormValid = data;
    this.formValidate();
  }
}
